<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width="740" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.px-3.py-2
      v-row(no-gutters align="center")
        v-col(cols="10" offset="1")
          .text-md.font-semibold.text-center Attach photo
        v-col(cols="1" align="right")
          v-btn(icon @click="showDialog = false" x-small color="primary")
            v-icon(size="20") mdi-close
    v-divider

    v-card-text.primary--text.pa-0
      v-row(no-gutters)
        v-col(cols="8")
          div.py-3.px-6
            v-card.round-xl.border-dashed.py-4.px-6.mb-4(link outlined)
              .text-center
                v-avatar.mb-3(color="neutral300" size="40")
                  v-icon(color="neutral500" size="18") $yzi-image-01
                .mb-1.text-sm
                  span.info500--text.font-semibold {{ $t('click_to_upload') }} 
                  span.neutral700--text {{ $t('or_drag_and_drop') }}
                .text-xs.neutral500--text {{ $t('photo_upload_limitation') }}
              input.input-change-layout(ref="file" type="file" @change="onFileChange" accept="image/*")
          v-divider
          div.px-6.py-4(v-if="databinPhotos.length || photos.length")
            //- uploaded photos
            template(v-for="photo in databinPhotos")
              div.py-2
                v-row(no-gutters align="center")
                  v-col(cols="2")
                    v-img(width="70" height="70" :src="$options.filters.smallImage(photo.file)" contain)
                  v-col.grow
                    div.px-4
                      div.text-xs.font-medium {{ photo.filename }}
                      div.text-xs.neutral500--text 100% {{ $t('uploaded') }}
                  v-col.shrink
                    v-btn(icon @click="deleteImage(photo)" x-small color="primary")
                      v-icon(size="20") mdi-close
            //- uploading photos
            template(v-for="photo in photos")
              div.py-2
                v-row(no-gutters align="center")
                  v-col(cols="2")
                    v-img(width="70" height="70" :src="require('@/assets/image_placeholder.png')" contain)
                  v-col.grow
                    div.px-4
                      div.text-xs.font-medium {{ photo.file.name }}
                      div.text-xs.neutral500--text {{ photo.file.size | bytesToSize }} - {{ photo.progress }}% {{ $t('uploaded') }}
                  v-col.shrink
                    v-progress-circular(size="22" width="3" :value="photo.progress" color="#0D6EFF")

          template(v-else)
            div.py-4.px-6
              div.text-xs.font-medium.neutral700--text No image uploaded yet
              div.text-xs.font-normal.neutral700--text Added image will appear here

        v-divider(vertical)
        v-col(cols="4")
          div.py-4.px-5
            .text-sm.font-medium.neutral700--text Add photo from other devices
            .text-xs.neutral700--text {{ $t('scan_qr_code_below_to_upload') }}
            v-card.round-xl.mt-6(outlined style="place-self: center;")
              vue-qrcode(v-if="databinKey" :value="getQRLinkURL()" :options="{ width: 150 }")

    v-divider
    v-card-actions.py-4.px-6
      v-btn.button-md.underline.px-0(@click="showDialog = false" text) {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(@click="confirm" :loading="isLoading" color="primary" depressed :disabled="databinPhotos.length === 0") {{ $t('confirm') }}

</template>

<script>
import VueQrcode from '@chenfengyuan/vue-qrcode'
import { mapGetters, mapActions } from 'vuex'
// import { resizeImage } from '@/utils'
import { isFileSizeOverLimit } from '@/utils'

export default {
  name: 'AttachPhotoDialog',
  components: { VueQrcode },
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isLoading: false,
    isDeleting: false,
    photos: [],
    databinPhotos: [],
    polling: null
  }),
  computed: {
    ...mapGetters({
      databinKey: 'clinic/getDatabinKey'
    }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    // this.fetchDatabin()
    this.createDatabin()
  },
  methods: {
    ...mapActions(['showMessage']),
    async onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      if (isFileSizeOverLimit(files[0], 5)) {
        this.showMessage(['error', this.$t('error_message.file_reached_limit')])
        return
      }
      // const resizedImage = await resizeImage(files[0], `photo_${Date.now()}.jpeg`)
      const photo = {
        data: null,
        file: files[0],
        progress: 0
      }
      this.photos.push(photo)
      this.uploadPhoto(photo)
    },
    uploadPhoto (photo) {
      const formData = new FormData()
      formData.append('file', photo.file)
      this.$axios.post(`/documents/`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: progressEvent => (photo.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total))
        })
        .then(resp => {
          const uploadedPhoto = resp.data
          this.uploadToDatabin(uploadedPhoto)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    fetchDatabin () {
      if (!this.databinKey) {
        this.createDatabin()
        return
      }
      this.$axios.get(`/databin/${this.databinKey}`)
        .then(resp => {
          if (JSON.stringify(resp.data) !== '{}') {
            this.databinPhotos = resp.data
          }
        })
        .catch(() => {
          this.createDatabin()
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.startPolling()
        })
    },
    refreshDatabin () {
      this.$axios.get(`/databin/${this.databinKey}`)
        .then(resp => {
          if (JSON.stringify(resp.data) !== '{}') {
            this.databinPhotos = resp.data
          }
        })
        .catch(() => {
        })
        .finally(() => {
        })
    },
    createDatabin () {
      this.$axios.post('/databin/?ttl=900')
        .then(resp => {
          this.$store.commit('clinic/setDatabinKey', resp.data.key)
          this.startPolling()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    uploadToDatabin (photo) {
      const data = [...this.databinPhotos, photo]
      if (this.databinKey) {
        this.$axios.put(`/databin/${this.databinKey}/?ttl=900`, data)
          .then(resp => {
            this.databinPhotos = resp.data.data
            this.photos.pop(photo)
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
      }
    },
    deleteImage (photo) {
      this.isDeleting = true
      this.stopPolling()
      this.databinPhotos = this.databinPhotos.filter(p => p.hid !== photo.hid)
      this.updateDatabin()
      this.startPolling()
      this.isDeleting = false
    },
    updateDatabin () {
      const data = [...this.databinPhotos]
      if (this.databinKey) {
        this.$axios.put(`/databin/${this.databinKey}/?ttl=900`, data)
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
      }
    },
    getQRLinkURL () {
      return encodeURI(`https://${process.env.VUE_APP_BASE_DOMAIN}/upload-photo/${this.databinKey}`)
    },
    confirm () {
      this.showDialog = false
      this.$emit('onUpload', this.databinPhotos)
    },
    startPolling () {
      this.stopPolling()
      this.polling = setInterval(() => {
        this.refreshDatabin()
      }, 4000)
    },
    stopPolling () {
      clearInterval(this.polling)
    }
  },
  destroyed () {
    this.stopPolling()
  }
}
</script>

<style scoped>
.file-layout {
  position: relative;
  cursor: pointer;
  border: var(--v-neutral400) dashed 1px;
}
.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
</style>